import { NJTag, NJText } from "@engie-group/fluid-design-system-react";

/** A labelled row of NJTag pills (use cases, harnesses, categories…). */
export function MetaTagList({
  label,
  items,
  emptyLabel = "None",
  max,
}: {
  label: string;
  items: string[];
  emptyLabel?: string;
  max?: number;
}) {
  const shown = max ? items.slice(0, max) : items;
  return (
    <div className="flex flex-col gap-1.5">
      <NJText
        as="span"
        scale="xs"
        className="font-nj-bold uppercase tracking-wide text-nj-neutral-secondary-default"
      >
        {label}
      </NJText>
      <div className="flex flex-wrap gap-2">
        {shown.length > 0 ? (
          shown.map((item) => (
            <NJTag key={item} label={item} variant="grey" size="sm" />
          ))
        ) : (
          <NJText
            as="span"
            scale="xs"
            className="text-nj-neutral-tertiary-default"
          >
            {emptyLabel}
          </NJText>
        )}
      </div>
    </div>
  );
}
